import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { ExternalConnectionsListQuery, GetExternalConnectionsInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const QUERY_EXTERNAL_CONNECTIONS_LIST = gql`
    query externalConnectionsList($input: GetExternalConnectionsInput!) {
        externalConnections(input: $input) {
            nodes {
                description
                externalConnectionType
                isForClient
                isForPartner
            }
        }
    }
`;

export const queryExternalConnectionList = async (
    client: ApolloClient<NormalizedCacheObject>,
    filters?: GetExternalConnectionsInput
) => {
    const { isForClient, isForPartner } = filters ?? {};
    
    const { data, errors } = await client.query<ExternalConnectionsListQuery>({
        query: QUERY_EXTERNAL_CONNECTIONS_LIST,
        variables: { 
            input: { 
                isForClient, 
                isForPartner 
            } 
        }
    });

    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console.
            console.error(error);
        });
        // Friendly error to the user.
        throw new Error('An error has occurred during the query.');
    }

    return data?.externalConnections?.nodes;
};
